import { BrowserRouter as Router, Routes as Rts, Route } from 'react-router-dom'
import { useLocalStorage } from './contexts/LocalStorageContext'
import { Asr, Home, Ocr } from './views'
import Config from './views/Config'
import Tasks from './views/Tasks'
import OcrNext from './views/OcrNext'
import Welcome from './views/Welcome'
import History from './views/History'

const Routes = () => {
  const { config, localStorageLoaded } = useLocalStorage()

  return (
    <>
      { localStorageLoaded ? (
        <>
          { config?.welcome ? (
            <Rts>
              <Route path="/" element={<Home />} />
              <Route path="/asr" element={<Asr />} />
              <Route path="/config" element={<Config />} />
              <Route path="/history" element={<History />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/ocr" element={<Ocr />} />
              <Route path="/ocr-next" element={<OcrNext />} />
            </Rts>
          ) : (
            <Welcome />
          )}
        </>
      ) : (
        <div className="text-center">
          Chargement des données en cours
        </div>
      )}
    </>
  )
}

export default Routes
